<template>
  <div class="devOps_producerSpaceSet">
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="50px" style="margin-top: 10px;">
      <el-form-item label="名称" label-width="40px">
        <el-input :style="iptStyle" placeholder="请输入"  v-model="form.work_name" />
      </el-form-item>
      <el-form-item label="类别">
        <el-select  filterable clearable collapse-tags size="mini" v-model="form.type"  placeholder="请选择">
          <el-option v-for="(key, value) in types" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="创建人">
        <el-select size="mini" autocomplete="off" v-model="form.creator_id"  clearable collapse-tags
                   filterable placeholder="请选择">
          <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select size="mini" autocomplete="off" v-model="form.state" collapse-tags filterable clearable placeholder="请选择状态">
          <el-option v-for="(key, value) in allStatus" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary" @click="formSearch('reset','search')" v-if="menu.btn_data_query">查询
        </el-button>
        <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary" @click="showDialogVisible('addCategory')" v-if="menu.btn_data_add">新增
        </el-button>
      </el-form-item>
    </el-form>
    <div style="height: 65vh">
  <el-table height="100%" :header-cell-style="getCellClass" row-key="id" ref="multipleTable" style="margin-top:0;" :cell-style="getRowClass" :data="tableData">
    <el-table-column prop="value" label="名称" min-width="100" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="desc" label="类别" width="80" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="creator_id" label="创建人" width="130"  :show-overflow-tooltip="true">
      <template slot-scope="scope">
        <span>{{ scope.row.creator_id.nameZh ? scope.row.creator_id.nameZh: '' }} {{ scope.row.creator_id.nameEn ? '('+scope.row.creator_id.nameEn+')': '' }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="state" label="状态" width="80"  :show-overflow-tooltip="true">
      <template slot-scope="scope">
        <span>{{ scope.row.state == 1 ? '有效': '无效' }} </span>
      </template>
    </el-table-column>
    <el-table-column prop="create_time" label="创建时间" width="130" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="updater_id" label="修改人" width="130" :show-overflow-tooltip="true">
      <template slot-scope="scope">
        <span>{{ scope.row.updater_id.nameZh ? scope.row.updater_id.nameZh: '' }} {{ scope.row.updater_id.nameEn ? '('+scope.row.updater_id.nameEn+')': '' }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="update_time" label="修改时间"  width="130" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column fixed="right" label="操作" width="100px" v-show="menu.btn_data_edit">
      <template slot-scope="scope">
        <div style="display: flex;">
          <el-button v-if="menu.btn_user_edit" type="primary" round size="mini" @click="showDialogVisible('addCategory', scope.row)">修改</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
    </div>
    <div class="block devOpsSpace_page">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="total">
      </el-pagination>
    </div>
    <AddCategory  v-if="dialogVisible.addCategory" :dialogVisible='dialogVisible.addCategory' :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></AddCategory>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {
  getDevOpsSpaceDictionariesTypeListlApi,
  getDevOpsSpaceUserManageListApi, getDevOpsSpaceUserRoleListApi, getDevOpsSpaceWorkOrderCategoryListlApi,
  postDevOpsSpaceDeleteProjectCommentApi,
  postDevOpsSpaceDleteUserApi
} from "@/server/tops/devOps";
import AddCategory from "@/views/tops/devOps/settingSpace/components/category/addCategory.vue";
import {getDevOpsSpaceMenuListListApi} from "@/server/tops/base";
export default {
  components: {AddCategory },
  data() {
    return {
      tableData: [],
      searchData: [],
      form:{
        work_name:'',
        state:'1',
        creator_id:'',
        type:'',
      },
      dialogVisible:{
        addCategory: false,
      },
      checkedInfo:{},
      currentPage: 1,
      pageSize:10,
      total:0,
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      allStatus:{'0':'无效','1':'有效'},
      menu:{},
      allRoles: [],
      types:[],
    }
  },
  async created() {
    await this.getAuth();
    await this.getDictionariesTypeList();
    await this.getNewData();
    await this.getUserRoleList();
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allMenuList: (state) => state.devOps.ALLMENULIST,
          allUserList: (state) => state.devOps.NEWALLUSERLIST,
        }
    ),
  },
  methods: {
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    async getNewData(){
      let params = {}
      params.pageNo = this.currentPage
      params.pageSize = this.pageSize
      params.work_name = this.form.work_name;
      params.creator_id = this.form.creator_id;
      params.state = this.form.state;
      params.type = this.form.type;
      getDevOpsSpaceWorkOrderCategoryListlApi(params).then((res)=>{
        this.tableData = res.data;
        this.total = res.count;
      })
    },
    async getDictionariesTypeList() {
      const ret = await getDevOpsSpaceDictionariesTypeListlApi();
      let arr = {};
      if(ret.status === 'success'){
        ret.data.forEach((item,index)=>{
          arr[item.type] = item.desc;
        });
      }
      this.types = arr;
    },
    onDeleteUser(id){
      this.$confirm("此操作将删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        postDevOpsSpaceDleteUserApi({id:id}).then(async (ret) => {
          if (ret.status === 'success') {
            this.$notify({
              message: ret.message || '删除成功',
              type: "success",
            })
            await this.getNewData();
          } else {
            this.$notify({
              message: ret.message || "失败",
              type: "error",
            })
          }
        })
      });
    },
    // 弹出模板
    async showDialogVisible(type, row) {
      this.dialogVisible[type] = true;
      if(row){
        row.is_update = 1;
      }
      this.checkedInfo = row;
    },
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      await this.getNewData();
    },
    formSearch(){
      let newTableData = [];
      this.currentPage = 1;
      this.getNewData();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1;
      this.getNewData();
    },
    handleCurrentChange(val) {
      this.getNewData();
      //this.currentPage = val
    },
    async getAuth() {
      let menu = {}
      await getDevOpsSpaceMenuListListApi().then((res) => {
        res.data.btnList.forEach((item) => {
            menu[item.code] = 1;
        })
      })
      this.menu = menu;
    },
    async getUserRoleList(){
      let arr = {};
      await  getDevOpsSpaceUserRoleListApi().then((ret)=>{
        ret.data.forEach((item)=>{
          arr[item.id] = item.name;
        })
      })
      this.allRoles = arr;
    },
  }
}
</script>
<style lang="scss">
.devOps_producerSpaceSet{
  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
}
.el-message-box__wrapper {
  bottom: initial !important;
  top:10%;
}
</style>
